import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


const $qs = (css, parent = document) => parent.querySelector(css);
const $qsa = (css, parent = document) => parent.querySelectorAll(css);


function homeBannerAnimation() {
  
  // Set up variables
  const navBar = $('.top-nav'); 
  const homeVideoContainer = $('.js-home-video');
  const homeVideoIllustration = $('.js-home-video-illustration');
  const homeVideoWrapper = $('.js-home-video-wrapper'); 
  const homeVideoInnerWrapper = $('.js-home-video-inner-wrapper'); 
  const homeVideoTitle = $('.js-home-video-title');
  const homeIntro = $('.js-home-intro'); 
  const cheamCircle = $('.js-cheam-logo-circle'); 
  let yValue = '-710';
  let paddingX = '80';
  if (window.matchMedia('(max-width: 767px)').matches) {
    paddingX = '0';
  } else if (window.matchMedia('(max-width: 991px)').matches) {
    yValue = '-645';
    paddingX = '40';
  } else if (window.matchMedia('(max-width: 1279px)').matches) {
    yValue = '-680';
  }
 


  gsap.set(navBar, {opacity: 0 });
  gsap.set(cheamCircle, {opacity: 0 });
  gsap.set(homeIntro, {opacity: 0 });
  gsap.set(homeVideoIllustration, {opacity:0 });
  gsap.set(homeVideoTitle, {opacity:0});
  if ( window.matchMedia('(min-width: 768px)').matches) {
    gsap.set(homeVideoContainer, { y: yValue, width: "100%", height: "100vh", pointerEvents: "none"  } );
    gsap.set(homeVideoWrapper, { borderRadius: 0, width: "100%", height: "100vh"} );
    gsap.set(homeVideoInnerWrapper, { height: "100vh" } );
  } else {
    gsap.set( homeVideoContainer, { y: 0, paddingLeft: paddingX, paddingRight: paddingX, height: "auto", pointerEvents: "auto", } );
  }


  // Banner Loading animation
  const loadBannerTL = gsap.timeline();
  if ( window.matchMedia('(min-width: 768px)').matches) {
    loadBannerTL.delay(0.5);
    loadBannerTL.to( homeVideoContainer, { y: 0, paddingLeft: paddingX, paddingRight: paddingX, height: "auto", pointerEvents: "auto",  duration: 2.5, ease: "power2.inOut" } );
    loadBannerTL.to( homeVideoWrapper, { height: "auto", borderRadius: 20, duration: 1.2, ease: "power2.inOut"}, ">-=1.1" );
    loadBannerTL.to( homeVideoInnerWrapper, { height: "auto", duration: 1.2, ease: "power2.inOut"}, ">-=1.1" );
  }
  loadBannerTL.to( homeIntro, {opacity: 1, duration: 2, ease: "power2.inOut"}, ">-=2.1" );
  loadBannerTL.to( navBar, {opacity: 1, duration: 1.2, ease: "power2.inOut"}, ">-=1.1" );
  loadBannerTL.to( cheamCircle, {opacity: 1, duration: 1.2, ease: "power2.inOut"}, ">-=1.1" );
  loadBannerTL.to( homeVideoIllustration, {opacity: 1, duration: 3.2, ease: "power2.inOut"}, ">-=1.1" );
  loadBannerTL.to( homeVideoContainer, {zIndex: 1, duration: 1.2}, ">-=1.1");
  loadBannerTL.to( cheamCircle, {zIndex: 2, duration: 1.2}, ">-=1.1");
  loadBannerTL.to( homeVideoTitle, { opacity:1, duration: 2, ease: "power2.inOut" }, ">-=1.1")
}


function homeTeaserAnimation() {
  const videoTeaser = $('.js-homepage-scroll-top--video');
  const exploreMessage = $('.js-home-teaser-title');
  const teaserOne = $('.js-home-teaser-item-one');
  const teaserTwo = $('.js-home-teaser-item-two');

  const sections = $qsa('.js-homepage-section');
  const getMaxHeight = () => [...sections].reduce((val, section) => val + section.offsetHeight, 0);
  const maxHeight = getMaxHeight();
  const scrollSpeed = 4;


  if (window.matchMedia('(min-width: 1100px)').matches) {
    const teaserAnimation = gsap.timeline({
      ease: 'none',
      scrollTrigger: {
        trigger: ".js-scroll-section", 
        pin: true,
        scrub: 0.2,
        start: "top top",
        end: () => `+=${maxHeight / scrollSpeed}`,
        toggleActions: "play pause play reset",
        //markers: true,
      }
    });


    teaserAnimation.fromTo( videoTeaser, { clipPath: "inset(0% 0% 0% 0%)", yPercent:0 }, { clipPath: "inset(15% 15% 15% 15%)", yPercent: -100 } );
    teaserAnimation.fromTo( exploreMessage, { opacity: 0 }, { opacity: 1 }, ">-0.4"  );
    teaserAnimation.addLabel('teasers');
    teaserAnimation.fromTo( teaserOne, { clipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% -5% 0% 0%)" }, '<+0.5' );
    teaserAnimation.fromTo( teaserTwo, { clipPath: "inset(0% 0% 0% 100%)" }, { clipPath: "inset(0% 0% 0% -5%)" }, '<' );


    ScrollTrigger.sort();
  }
}



function homeAnimation() {
  homeBannerAnimation();
  homeTeaserAnimation();
}

export default homeAnimation;
